/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  console.log("✅ custom.js chargé !");

  document.addEventListener("DOMContentLoaded", function () {
    console.log("📱 JS exécuté");

    function refreshCartBubble() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          let bubbles = document.querySelectorAll('.cart-count-bubble span');

          // Si aucun span trouvé, tenter de créer la bulle
          if (bubbles.length === 0) {
            const bubbleContainer = document.querySelector('.cart-count-bubble');
            if (bubbleContainer) {
              const newSpan = document.createElement('span');
              bubbleContainer.appendChild(newSpan);
              bubbles = [newSpan];
              console.log("🧱 Bulle span créée dynamiquement.");
            } else {
              console.warn("⚠️ Aucun conteneur .cart-count-bubble trouvé.");
              return;
            }
          }

          bubbles.forEach(bubble => {
            bubble.textContent = cart.item_count;
            bubble.parentElement.style.display = cart.item_count > 0 ? 'flex' : 'none';
          });
        })
        .catch(err => {
          console.error("❌ Erreur mise à jour bubble:", err);
        });
    }

    document.querySelectorAll('form[action^="/cart/add"]').forEach(form => {
      form.addEventListener('submit', function () {
        console.log("🛒 Produit ajouté via AJAX, mise à jour bubble...");
        setTimeout(() => {
          refreshCartBubble();
        }, 700);
      });
    });

    const cartDrawer = document.querySelector('#cart-drawer');
    if (cartDrawer) {
      const observer = new MutationObserver(() => {
        console.log("🌀 Modification panier détectée !");
        refreshCartBubble();
      });

      observer.observe(cartDrawer, { childList: true, subtree: true });
    }

    // Affichage initial : on cache tout si vide
    const bubbleContainers = document.querySelectorAll('.cart-count-bubble');
    bubbleContainers.forEach(container => {
      const span = container.querySelector('span');
      if (!span) {
        const newSpan = document.createElement('span');
        container.appendChild(newSpan);
      }
      container.style.display = 'none';
    });

    refreshCartBubble();
  });
})();

  
  
  // Masquer le nombre de produits du panier quand il est à 0
  
  function updateCartQtyDisplay() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartQtyEl = document.querySelector('.cart-drawer__item-qty');
        if (cartQtyEl) {
          if (cart.item_count > 0) {
            cartQtyEl.style.display = 'inline-block';
          } else {
            cartQtyEl.style.display = 'none';
          }
        }
      })
      .catch(error => console.error('Erreur lors de la mise à jour du compteur du panier:', error));
  }
  
  // Mettre à jour l'affichage au chargement de la page
  document.addEventListener('DOMContentLoaded', updateCartQtyDisplay);
  
  // Mettre à jour l'affichage après chaque ajout ou suppression d'article
  document.addEventListener('cart:updated', updateCartQtyDisplay);

document.addEventListener('DOMContentLoaded', () => {
  updateCartQtyDisplay();

  const cartDrawer = document.querySelector('#cart-drawer');

  if (cartDrawer) {
    const observer = new MutationObserver(() => {
      updateCartQtyDisplay();
    });

    observer.observe(cartDrawer, { childList: true, subtree: true });
  }
});
